export default __webpack_public_path__ + "static/media/13.71b6f816.jpeg";